/**
 * @desc 导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.storageDamageMaster.exporting.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/storageDamageMaster/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
